import { supabase } from '@/integrations/supabase/client';

/**
 * Resolve media value to a browser-safe public URL.
 * - Absolute URL => returned as-is
 * - Relative storage path => resolved via public-media bucket
 */
export function resolvePublicMediaUrl(pathOrUrl: string | null | undefined): string | null {
  if (!pathOrUrl) return null;

  const trimmed = pathOrUrl.trim();
  if (!trimmed) return null;

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  const { data } = supabase.storage.from('public-media').getPublicUrl(trimmed);
  return data.publicUrl || null;
}
